import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../Icon'

import * as styles from './DashboardTileGrip.module.css'

import DragIcon from '../../../../icons/drag-and-drop.svg'

function DashboardTileGrip() {
  return (
    <IconNG
      Icon={DragIcon}
      className={styles.grip}
      color={ICON_COLOR.TextDisabledColor}
      size={ICON_HEIGHT_16}
    />
  )
}

export default DashboardTileGrip
